import { 
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom'
import Home from './pages/home'
import Detail from './pages/detail'
import Testing from './pages/testing'
import Result from './pages/result'
import SharePreview from './pages/sharePreview'

const router = createBrowserRouter([
  {
    path: '/:oid',
    element: <Home />,
  },
  {
    path: '/detail/:oid/:code',
    element: <Detail />,
  },
  {
    path: '/testing/:oid/:code',
    element: <Testing />,
  },
  {
    path: '/result/:oid/:code',
    element: <Result />,
  },
  {
    path: '/:oid/share/:code',
    element: <SharePreview />,
  },
])

export default function Router() {
  return (
    <RouterProvider router={router} />
  )
}
